import { render, staticRenderFns } from "./ReActivateUser.vue?vue&type=template&id=0b41ed2e&"
import script from "./ReActivateUser.vue?vue&type=script&lang=js&"
export * from "./ReActivateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports